import { Box,  VStack } from "@chakra-ui/react";

export default function UnifiedTextBlockSection({ items = [] }) {
  if (!items.length) return null;

  return (
    <VStack spacing={0.5} align="stretch">
      {items.map((item, index) => (
        <Box
          key={`${index}-${item.slice(0, 32)}`}
          bg="white"
          border="1px solid"
          borderColor="gray.100"
          borderRadius="xl"
          px={{ base: 2, md: 2 }}
          py={1}
        >
            {item}
        </Box>
      ))}
    </VStack>
  );
}
